// extracted by mini-css-extract-plugin
var _1 = "ApplicantFitCheckBlockTitle-moduleApplicantFitCheckBlockTitle__L8YgN";
var _2 = "ApplicantFitCheckBlockTitle-modulebadge__gpBwf";
var _3 = "ApplicantFitCheckBlockTitle-modulecoverage__J8SmL";
var _4 = "ApplicantFitCheckBlockTitle-modulereevaluate__edJLb";
var _5 = "ApplicantFitCheckBlockTitle-modulering__futYm";
var _6 = "ApplicantFitCheckBlockTitle-modulescore__VJ5v3";
var _7 = "ApplicantFitCheckBlockTitle-modulestale__rLDty";
export { _1 as "ApplicantFitCheckBlockTitle", _2 as "badge", _3 as "coverage", _4 as "reevaluate", _5 as "ring", _6 as "score", _7 as "stale" }
